import { useEffect } from "react";
import { FaArrowRight } from "react-icons/fa";
import AuthShell, { authLink } from "../../components/AuthShell";

export default function SignUp() {

    useEffect(() => {
        if (window.localStorage.token) {
            window.location.replace('/dashboard');
        }
    }, []);

    return (
        <AuthShell
            footer={<>
                <div className="text-slate-500">
                    Already have an account? <a href="/signin" className={authLink}>Sign In</a>
                </div>
                <a href="https://kptd.ph/remote" className="font-semibold text-slate-500 transition hover:text-slate-900">
                    Go back to home
                </a>
            </>}>

            <div className="text-center">

                <img src="/mikrouter-logo.svg" alt="MikRouter logo" className="mx-auto h-20 w-20 rounded-3xl shadow-xl shadow-emerald-900/20" />

                <div className="mt-5 flex flex-row items-center justify-center gap-2">
                    <span className="text-xl font-bold tracking-tight text-slate-900">MikRouter</span>
                    <span className="rounded-full bg-emerald-50 px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider text-[#047857] ring-1 ring-inset ring-emerald-200">
                        New website
                    </span>
                </div>

                <p className="mt-4 text-sm leading-relaxed text-slate-600">
                    Registration is no longer available here. We have moved to our new
                    website, <span className="font-bold text-slate-900">mikrouter.com</span> &mdash; please
                    create your account there instead.
                </p>
            </div>

            <a
                href="https://mikrouter.com"
                target="_blank"
                rel="noreferrer"
                className="group mt-7 flex min-h-[46px] flex-row items-center justify-center gap-2 rounded-xl bg-gradient-to-b from-[#10b981] to-[#059669] px-4 py-3 text-sm font-bold text-white shadow-lg shadow-emerald-600/25 transition-all hover:brightness-110 active:scale-[0.99]">
                Go to mikrouter.com
                <FaArrowRight className="transition-transform group-hover:translate-x-1" />
            </a>

        </AuthShell>
    )
}
